import type {
  CsrPlayerElement,
  MetricEvent,
} from '@spotify-internal/csr-player';

import { FullPlaybackControls } from './FullPlaybackControls';
import { SimplifiedPlaybackControls } from './SimplifiedPlaybackControls';
import type { PlaybackDefaults } from './usePlaybackState';

type PlaybackControlsVariant = 'full' | 'simplified';

type PlaybackControlsProps = {
  player: CsrPlayerElement;
  metricEvents?: MetricEvent[];
  variant?: PlaybackControlsVariant;
  initialPageUrl?: string;
  playbackDefaults?: PlaybackDefaults;
  onEventMarkerClick?: (timestampSeconds: number) => void;
};

export const PlaybackControls = ({
  player,
  metricEvents = [],
  variant = 'full',
  initialPageUrl,
  playbackDefaults,
  onEventMarkerClick,
}: PlaybackControlsProps) => {
  if (variant === 'simplified') {
    return (
      <SimplifiedPlaybackControls
        player={player}
        metricEvents={metricEvents}
        playbackDefaults={playbackDefaults}
      />
    );
  }

  return (
    <FullPlaybackControls
      player={player}
      metricEvents={metricEvents}
      initialPageUrl={initialPageUrl}
      playbackDefaults={playbackDefaults}
      onEventMarkerClick={onEventMarkerClick}
    />
  );
};
